import { User, Message } from "@/types/incidents";
import { UserType } from "@/types/user";


const formatMessageForCopy = (message: Message, user?: User) => {
  switch (message.userType) {
    case UserType.APP_USER: {
      const userDetails = user?.name || "";

      return `${userDetails} | ${message.message}`;
    }
    case UserType.OPERATOR:
      return `Operator | ${message.message}`;
    case UserType.ADMINISTRATOR:
      return `Administrator | ${message.message}`;
    case UserType.DISPATCHER:
      return `Responder | ${message.message}`;
    default:
      return message.message;
  }
};
export default formatMessageForCopy;
